import { Menu } from 'antd'
import React from 'react'
import './InlineMenu.css'

const InlineMenu = ({ ...props }) => {
  return (
    <Menu
      mode="inline"
      {...props}
    />
  )
}

export default InlineMenu
